import React from 'react'

const Popup = ({ children, onClose }) => (
  <div className="fixed-top" onClick={onClose}>
    {children}
  </div>
)

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup.js